import BtnNext from './btn-next';

export default BtnNext;
